var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Moon = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 981.58 981.58", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M972.21 644.53a32 32 0 0 0-35.82-6.53 447.58 447.58 0 0 1-501.17-91.63 448.45 448.45 0 0 1-91.64-501.18 32 32 0 0 0-42.34-42.35 512.1 512.1 0 1 0 452.82 918 508.584 508.584 0 0 0 37.32-22.15 32 32 0 1 0-35-53.6 445.616 445.616 0 0 1-32.65 19.38A448.09 448.09 0 0 1 256 101.81a511.65 511.65 0 0 0 134 489.81 513.2 513.2 0 0 0 489.72 133.94 448.47 448.47 0 0 1-32.84 41.61 32 32 0 1 0 47.83 42.53 512.16 512.16 0 0 0 84-129.35 32 32 0 0 0-6.5-35.82z", fill: "currentColor", "data-name": "Layer 2" }))); };
export default Moon;
//# sourceMappingURL=Moon.js.map